const messages = {
  vi: {
    auth: {
      login: 'Đăng nhập',
      logout: 'Đăng xuất',
      email: 'Email',
      password: 'Mật khẩu',
      emailPlaceholder: 'Nhập email của bạn',
      passwordPlaceholder: 'Nhập mật khẩu',
      loginFailed: 'Đăng nhập thất bại',
      loginSuccess: 'Đăng nhập thành công',
    },
    validation: {
      emailRequired: 'Email là bắt buộc',
      emailInvalid: 'Email không hợp lệ',
      passwordRequired: 'Mật khẩu là bắt buộc',
      required: 'Trường này là bắt buộc',
      minLength: 'Ít nhất {min} ký tự',
      positiveNumber: 'Phải là số dương',
    },
    admin: {
      adminLogin: 'Đăng nhập quản trị',
      dashboard: 'Bảng điều khiển',
      customers: 'Khách hàng',
      commerce: 'Thương mại',
      plans: 'Gói dịch vụ',
      subscriptions: 'Đăng ký',
      payments: 'Thanh toán',
      tts: 'TTS',
      ttsJobs: 'Công việc TTS',
      ttsCatalog: 'Catalog TTS',
      voices: 'Giọng (voiceId)',
      models: 'Mô hình (modelId)',
      ttsMethods: 'Phương án TTS',
      syncFromDisk: 'Đồng bộ từ disk',
      finetuningRoot: 'Thư mục finetuning',
      catalogName: 'Tên',
      language: 'Ngôn ngữ',
      status: 'Trạng thái',
      confirmDelete: 'Xóa mục này?',
      createVoice: 'Thêm giọng',
      editVoice: 'Sửa giọng',
      createModel: 'Thêm mô hình',
      editModel: 'Sửa mô hình',
      createMethod: 'Thêm phương án',
      editMethod: 'Sửa phương án',
      queue: 'Hàng đợi',
      auditLogs: 'Nhật ký kiểm tra',
      admins: 'Quản trị viên',
      recentFailedPayments: 'Thanh toán thất bại gần đây',
      queueOverview: 'Tổng quan hàng đợi',
      systemOverview: 'Tổng quan hệ thống',
      noQueueData: 'Chưa có dữ liệu hàng đợi.',
      noFailedPayments: 'Không có thanh toán thất bại gần đây.',
      customerDetail: 'Chi tiết khách hàng',
      lockUser: 'Khóa tài khoản',
      unlockUser: 'Mở khóa tài khoản',
      locked: 'Đã khóa',
      active: 'Hoạt động',
      noCustomers: 'Chưa có khách hàng nào.',
      createPlan: 'Tạo gói',
      editPlan: 'Sửa gói',
      deletePlan: 'Xóa gói',
      planName: 'Tên gói',
      planSlug: 'Slug',
      monthlyPrice: 'Giá hàng tháng',
      yearlyPrice: 'Giá hàng năm',
      charLimit: 'Giới hạn ký tự',
      concurrentJobs: 'Công việc đồng thời',
      queuePriority: 'Ưu tiên hàng đợi',
      queuePriorityHint: 'Số càng cao, job được xử lý ưu tiên hơn trong hàng đợi (mặc định 0).',
      maxStorage: 'Dung lượng tối đa (MB)',
      currency: 'Loại tiền',
      description: 'Mô tả',
      features: 'Tính năng',
      featuresJsonHint: 'Mảng JSON, ví dụ: ["TTS không giới hạn", "Hỗ trợ ưu tiên"].',
      formSectionBasic: 'Thông tin cơ bản',
      formSectionBasicDesc: 'Tên hiển thị, slug và trạng thái gói.',
      formSectionPricing: 'Giá và thanh toán',
      formSectionPricingDesc: 'Giá theo chu kỳ và đơn vị tiền tệ.',
      formSectionLimits: 'Hạn mức và hàng đợi',
      formSectionLimitsDesc: 'Giới hạn ký tự, job đồng thời, dung lượng và ưu tiên xử lý.',
      formSectionAdvanced: 'Nâng cao',
      planActive: 'Kích hoạt gói',
      noPlans: 'Chưa có gói nào.',
      subscriptionStatus: 'Trạng thái',
      billingCycle: 'Chu kỳ',
      autoRenew: 'Tự động gia hạn',
      periodEnd: 'Kết thúc kỳ',
      cancelSubscription: 'Hủy đăng ký',
      reactivateSubscription: 'Kích hoạt lại',
      assignSubscription: 'Đăng ký gói',
      renewSubscription: 'Gia hạn',
      selectCustomer: 'Chọn khách hàng',
      selectPlan: 'Chọn gói',
      resetUsageOnRenew: 'Đặt lại mức sử dụng kỳ mới',
      assignSubscriptionConfirm: 'Đăng ký gói này cho khách hàng đã chọn?',
      renewSubscriptionConfirm: 'Gia hạn đăng ký này thêm một chu kỳ?',
      noSubscriptions: 'Chưa có đăng ký nào.',
      paymentAmount: 'Số tiền',
      paymentStatus: 'Trạng thái',
      paymentDate: 'Ngày',
      markAsPaid: 'Đánh dấu đã thanh toán',
      refundPayment: 'Hoàn tiền',
      noPayments: 'Chưa có giao dịch nào.',
      jobStatus: 'Trạng thái',
      jobProgress: 'Tiến trình',
      jobChars: 'Ký tự',
      retryJob: 'Thử lại',
      runJobAgain: 'Chạy lại',
      runJobAgainConfirm: 'Chạy lại công việc này? Job sẽ được đưa vào hàng đợi với cùng tài liệu và cấu hình giọng/mô hình.',
      cancelJobConfirm: 'Hủy công việc này?',
      cancelJob: 'Hủy công việc',
      downloadOutput: 'Tải audio',
      jobDetail: 'Chi tiết công việc',
      jobInfo: 'Thông tin công việc',
      jobId: 'Mã công việc',
      document: 'Tài liệu',
      documentId: 'Mã tài liệu',
      documentContent: 'Nội dung gốc',
      normalizedText: 'Văn bản chuẩn hóa',
      documentDetail: 'Chi tiết tài liệu',
      noNormalizedText: 'Chưa có văn bản chuẩn hóa',
      noDocumentContent: 'Không có nội dung tài liệu',
      noDocuments: 'Chưa có tài liệu nào.',
      characters: 'Số ký tự',
      progress: 'Tiến trình',
      attempts: 'Số lần thử',
      queuedAt: 'Xếp hàng lúc',
      startedAt: 'Bắt đầu lúc',
      completedAt: 'Hoàn thành lúc',
      updatedAt: 'Cập nhật lúc',
      duration: 'Thời lượng',
      errorLog: 'Nhật ký lỗi',
      audioOutput: 'Đầu ra audio',
      downloadAudio: 'Tải audio',
      audioUnavailable: 'Không tải được file audio',
      jobLifecycle: 'Vòng đời công việc',
      timing: 'Thời gian',
      createdAt: 'Tạo lúc',
      jobIdColumn: 'Mã công việc',
      errorColumn: 'Lỗi',
      noJobs: 'Chưa có công việc nào.',
      pipelineStatus: 'Trạng thái pipeline TTS',
      workerOnline: 'Worker đang hoạt động',
      workerOffline: 'Worker không kết nối',
      workerNotConnected: 'Chưa có worker kết nối — khởi động worker TTS: npm run dev:worker hoặc ./scripts/dev.sh start',
      queueStatsUnavailable: 'Không đọc được thống kê hàng đợi RabbitMQ',
      queueStatsUnavailableDetail: '{base} (vhost {vhost}): {detail}',
      queueStatsUnavailableVhost: '{base} (vhost {vhost}). Kiểm tra RABBITMQ_URL và cổng Management API.',
      queueStatsUnavailableGeneric: '{base}. Kiểm tra RABBITMQ_URL và RABBITMQ_MANAGEMENT_PORT.',
      completedToday: 'Hoàn thành (24h)',
      failedToday: 'Thất bại (24h)',
      jobsUnit: '{count} job',
      queuedJobs: 'Job trong hàng đợi',
      queueLabel: 'Độ sâu hàng đợi:',
      cancelSubscriptionConfirm: 'Hủy đăng ký này?',
      reactivateSubscriptionConfirm: 'Kích hoạt lại đăng ký này?',
      markAsPaidConfirm: 'Đánh dấu giao dịch này đã thanh toán?',
      refundPaymentConfirm: 'Hoàn tiền giao dịch này?',
      lockCustomerConfirm: 'Khóa tài khoản khách hàng này?',
      unlockCustomerConfirm: 'Mở khóa tài khoản khách hàng này?',
      retryDlqConfirm: 'Thử lại tin nhắn DLQ này?',
      purgeDlqConfirm: 'Xóa vĩnh viễn tin nhắn DLQ này?',
      purgeMessageConfirm: 'Xóa tin nhắn này?',
      deletePlanConfirm: 'Xóa gói {name}?',
      provider: 'Nhà cung cấp',
      messages: 'Tin nhắn',
      consumers: 'Consumer',
      customer: 'Khách hàng',
      reason: 'Lý do',
      firstFailed: 'Lỗi lần đầu',
      lastFailed: 'Lỗi lần cuối',
      failureReason: 'Lý do thất bại',
      messageId: 'Mã tin nhắn',
      slug: 'Slug',
      samplePath: 'Đường dẫn mẫu (sample_path)',
      modelPath: 'Đường dẫn mô hình (model_path)',
      scriptLinux: 'Script Linux',
      scriptWindows: 'Script Windows',
      roleAdmin: 'Quản trị viên',
      roleSuperAdmin: 'Quản trị viên cấp cao',
      statusTrialing: 'Đang dùng thử',
      statusPastDue: 'Quá hạn thanh toán',
      statActiveLabel: 'Hoạt động:',
      statRunningLabel: 'Đang chạy:',
      statPastDueLabel: 'Quá hạn:',
      statMrrLabel: 'MRR:',
      amount: 'Số tiền',
      date: 'Ngày',
      accountLocked: 'Đã khóa tài khoản.',
      accountUnlocked: 'Đã mở khóa tài khoản.',
      dlqMessages: 'Tin nhắn DLQ',
      retryMessage: 'Thử lại',
      purgeMessage: 'Xóa',
      noDlqMessages: 'Không có tin nhắn trong DLQ.',
      queueStats: 'Thống kê hàng đợi',
      deadLetter: 'Dead Letter',
      auditActor: 'Tác nhân',
      auditAction: 'Hành động',
      auditResourceType: 'Loại tài nguyên',
      auditResourceId: 'ID tài nguyên',
      auditTimestamp: 'Thời gian',
      noAuditLogs: 'Không có nhật ký nào.',
      createAdmin: 'Tạo quản trị viên',
      adminEmail: 'Email',
      adminUsername: 'Tên người dùng',
      adminPassword: 'Mật khẩu',
      adminRole: 'Vai trò',
      noAdmins: 'Chưa có quản trị viên nào.',
      save: 'Lưu',
      delete: 'Xóa',
      edit: 'Sửa',
      create: 'Tạo',
      search: 'Tìm kiếm',
      filter: 'Lọc',
      actions: 'Hành động',
      loading: 'Đang tải...',
      noData: 'Không có dữ liệu',
      success: 'Thành công',
      error: 'Lỗi',
      statusActive: 'Hoạt động',
      statusInactive: 'Không hoạt động',
      statusPending: 'Chờ xử lý',
      statusPaid: 'Đã thanh toán',
      statusFailed: 'Thất bại',
      statusRefunded: 'Đã hoàn tiền',
      statusCancelled: 'Đã hủy',
      statusCompleted: 'Hoàn thành',
      statusProcessing: 'Đang xử lý',
      statusQueued: 'Trong hàng đợi',
      statusFailedJob: 'Thất bại',
      monthly: 'Hàng tháng',
      yearly: 'Hàng năm',
    },
    common: {
      view: 'Xem',
      viewAll: 'Xem tất cả',
      retry: 'Thử lại',
      refresh: 'Làm mới',
      save: 'Lưu',
      cancel: 'Hủy',
      delete: 'Xóa',
      edit: 'Sửa',
      create: 'Tạo',
      search: 'Tìm kiếm',
      filter: 'Lọc',
      actions: 'Hành động',
      loading: 'Đang tải...',
      noData: 'Không có dữ liệu',
      confirm: 'Xác nhận',
      success: 'Thành công',
      error: 'Lỗi',
      yes: 'Có',
      no: 'Không',
      back: 'Quay lại',
      profile: 'Hồ sơ',
      folders: 'Thư mục',
      documents: 'Tài liệu',
      jobs: 'Công việc',
      billing: 'Thanh toán',
      subscription: 'Đăng ký',
      usage: 'Sử dụng',
      statistics: 'Thống kê',
      currentPeriod: 'Kỳ hiện tại',
      charsUsed: 'Ký tự đã dùng',
      charsLimit: 'Giới hạn',
      storage: 'Dung lượng',
      activeUsers: 'Người dùng hoạt động',
      totalUsers: 'Tổng người dùng',
      mrr: 'MRR',
      activeSubscriptions: 'Đăng ký hoạt động',
      failedPayments: 'Thanh toán thất bại',
      pastDue: 'Quá hạn',
      queueDepth: 'Độ sâu hàng đợi',
      runningJobs: 'Công việc đang chạy',
      completedJobs: 'Công việc hoàn thành',
    },
    tts: {
      voiceSelection: 'Chọn giọng',
      modelSelection: 'Chọn mô hình',
      status: {
        pending: 'Đang chờ',
        queued: 'Đã xếp hàng',
        processing: 'Đang xử lý',
        completed: 'Hoàn thành',
        failed: 'Thất bại',
        cancelled: 'Đã hủy',
      },
    },
  },
  en: {
    auth: {
      login: 'Login',
      logout: 'Logout',
      email: 'Email',
      password: 'Password',
      emailPlaceholder: 'Enter your email',
      passwordPlaceholder: 'Enter your password',
      loginFailed: 'Login failed',
      loginSuccess: 'Login successful',
    },
    validation: {
      emailRequired: 'Email is required',
      emailInvalid: 'Invalid email address',
      passwordRequired: 'Password is required',
      required: 'This field is required',
      minLength: 'Minimum {min} characters',
      positiveNumber: 'Must be a positive number',
    },
    admin: {
      adminLogin: 'Admin Login',
      dashboard: 'Dashboard',
      customers: 'Customers',
      commerce: 'Commerce',
      plans: 'Plans',
      subscriptions: 'Subscriptions',
      payments: 'Payments',
      tts: 'TTS',
      ttsJobs: 'TTS Jobs',
      ttsCatalog: 'TTS catalog',
      voices: 'Voices',
      models: 'Models',
      ttsMethods: 'TTS methods',
      syncFromDisk: 'Sync from disk',
      finetuningRoot: 'Finetuning root',
      catalogName: 'Name',
      language: 'Language',
      status: 'Status',
      confirmDelete: 'Delete this item?',
      createVoice: 'Add voice',
      editVoice: 'Edit voice',
      createModel: 'Add model',
      editModel: 'Edit model',
      createMethod: 'Add method',
      editMethod: 'Edit method',
      queue: 'Queue',
      auditLogs: 'Audit Logs',
      admins: 'Admins',
      recentFailedPayments: 'Recent Failed Payments',
      queueOverview: 'Queue Overview',
      systemOverview: 'System Overview',
      noQueueData: 'No queue data available.',
      noFailedPayments: 'No recent failed payments.',
      customerDetail: 'Customer Detail',
      lockUser: 'Lock Account',
      unlockUser: 'Unlock Account',
      locked: 'Locked',
      active: 'Active',
      noCustomers: 'No customers found.',
      createPlan: 'Create Plan',
      editPlan: 'Edit Plan',
      deletePlan: 'Delete Plan',
      planName: 'Plan Name',
      planSlug: 'Slug',
      monthlyPrice: 'Monthly Price',
      yearlyPrice: 'Yearly Price',
      charLimit: 'Character Limit',
      concurrentJobs: 'Concurrent Jobs',
      queuePriority: 'Queue priority',
      queuePriorityHint: 'Higher value means higher priority in the job queue (default 0).',
      maxStorage: 'Max Storage (MB)',
      currency: 'Currency',
      description: 'Description',
      features: 'Features',
      featuresJsonHint: 'JSON array, e.g. ["Unlimited TTS", "Priority support"].',
      formSectionBasic: 'Basic information',
      formSectionBasicDesc: 'Display name, slug, and plan status.',
      formSectionPricing: 'Pricing',
      formSectionPricingDesc: 'Billing cycle prices and currency.',
      formSectionLimits: 'Limits and queue',
      formSectionLimitsDesc: 'Character cap, concurrency, storage, and queue priority.',
      formSectionAdvanced: 'Advanced',
      planActive: 'Plan enabled',
      noPlans: 'No plans found.',
      subscriptionStatus: 'Status',
      billingCycle: 'Billing Cycle',
      autoRenew: 'Auto Renew',
      periodEnd: 'Period End',
      cancelSubscription: 'Cancel Subscription',
      reactivateSubscription: 'Reactivate Subscription',
      assignSubscription: 'Assign plan',
      renewSubscription: 'Renew',
      selectCustomer: 'Select customer',
      selectPlan: 'Select plan',
      resetUsageOnRenew: 'Reset usage for new period',
      assignSubscriptionConfirm: 'Assign this plan to the selected customer?',
      renewSubscriptionConfirm: 'Extend this subscription by one billing period?',
      noSubscriptions: 'No subscriptions found.',
      paymentAmount: 'Amount',
      paymentStatus: 'Status',
      paymentDate: 'Date',
      markAsPaid: 'Mark as Paid',
      refundPayment: 'Refund',
      noPayments: 'No payment transactions found.',
      jobStatus: 'Status',
      jobProgress: 'Progress',
      jobChars: 'Characters',
      retryJob: 'Retry',
      runJobAgain: 'Run again',
      runJobAgainConfirm: 'Run this job again? It will be requeued with the same document and voice/model settings.',
      cancelJobConfirm: 'Cancel this job?',
      cancelJob: 'Cancel Job',
      downloadOutput: 'Download',
      jobDetail: 'Job detail',
      jobInfo: 'Job information',
      jobId: 'Job ID',
      document: 'Document',
      documentId: 'Document ID',
      documentContent: 'Original content',
      normalizedText: 'Normalized text',
      documentDetail: 'Document detail',
      noNormalizedText: 'No normalized text yet',
      noDocumentContent: 'No document content',
      noDocuments: 'No documents found.',
      characters: 'Characters',
      progress: 'Progress',
      attempts: 'Attempts',
      queuedAt: 'Queued at',
      startedAt: 'Started at',
      completedAt: 'Completed at',
      updatedAt: 'Updated at',
      duration: 'Duration',
      errorLog: 'Error log',
      audioOutput: 'Audio output',
      downloadAudio: 'Download audio',
      audioUnavailable: 'Unable to load audio file',
      jobLifecycle: 'Job lifecycle',
      timing: 'Timing',
      createdAt: 'Created at',
      jobIdColumn: 'Job ID',
      errorColumn: 'Error',
      noJobs: 'No jobs found.',
      pipelineStatus: 'TTS pipeline status',
      workerOnline: 'Worker online',
      workerOffline: 'Worker offline',
      workerNotConnected: 'No worker connected — start the TTS worker with: npm run dev:worker or ./scripts/dev.sh start',
      queueStatsUnavailable: 'Cannot read RabbitMQ queue stats',
      queueStatsUnavailableDetail: '{base} (vhost {vhost}): {detail}',
      queueStatsUnavailableVhost: '{base} (vhost {vhost}). Check RABBITMQ_URL and Management API port.',
      queueStatsUnavailableGeneric: '{base}. Check RABBITMQ_URL and RABBITMQ_MANAGEMENT_PORT.',
      completedToday: 'Completed (24h)',
      failedToday: 'Failed (24h)',
      jobsUnit: '{count} jobs',
      queuedJobs: 'Queued jobs',
      queueLabel: 'Queue depth:',
      cancelSubscriptionConfirm: 'Cancel this subscription?',
      reactivateSubscriptionConfirm: 'Reactivate this subscription?',
      markAsPaidConfirm: 'Mark this payment as paid?',
      refundPaymentConfirm: 'Refund this payment?',
      lockCustomerConfirm: 'Lock this customer account?',
      unlockCustomerConfirm: 'Unlock this customer account?',
      retryDlqConfirm: 'Retry this DLQ message?',
      purgeDlqConfirm: 'Permanently purge this DLQ message?',
      purgeMessageConfirm: 'Purge this message?',
      deletePlanConfirm: 'Delete plan {name}?',
      provider: 'Provider',
      messages: 'Messages',
      consumers: 'Consumers',
      customer: 'Customer',
      reason: 'Reason',
      firstFailed: 'First failed',
      lastFailed: 'Last failed',
      failureReason: 'Failure reason',
      messageId: 'Message ID',
      slug: 'Slug',
      samplePath: 'Sample path (sample_path)',
      modelPath: 'Model path (model_path)',
      scriptLinux: 'Linux script',
      scriptWindows: 'Windows script',
      roleAdmin: 'Admin',
      roleSuperAdmin: 'Super Admin',
      statusTrialing: 'Trialing',
      statusPastDue: 'Past due',
      statActiveLabel: 'Active:',
      statRunningLabel: 'Running:',
      statPastDueLabel: 'Past due:',
      statMrrLabel: 'MRR:',
      amount: 'Amount',
      date: 'Date',
      accountLocked: 'Account locked.',
      accountUnlocked: 'Account unlocked.',
      dlqMessages: 'DLQ Messages',
      retryMessage: 'Retry',
      purgeMessage: 'Purge',
      noDlqMessages: 'No DLQ messages.',
      queueStats: 'Queue Statistics',
      deadLetter: 'Dead Letter',
      auditActor: 'Actor',
      auditAction: 'Action',
      auditResourceType: 'Resource Type',
      auditResourceId: 'Resource ID',
      auditTimestamp: 'Timestamp',
      noAuditLogs: 'No audit logs found.',
      createAdmin: 'Create Admin',
      adminEmail: 'Email',
      adminUsername: 'Username',
      adminPassword: 'Password',
      adminRole: 'Role',
      noAdmins: 'No admins found.',
      save: 'Save',
      delete: 'Delete',
      edit: 'Edit',
      create: 'Create',
      search: 'Search',
      filter: 'Filter',
      actions: 'Actions',
      loading: 'Loading...',
      noData: 'No data',
      success: 'Success',
      error: 'Error',
      statusActive: 'Active',
      statusInactive: 'Inactive',
      statusPending: 'Pending',
      statusPaid: 'Paid',
      statusFailed: 'Failed',
      statusRefunded: 'Refunded',
      statusCancelled: 'Cancelled',
      statusCompleted: 'Completed',
      statusProcessing: 'Processing',
      statusQueued: 'Queued',
      statusFailedJob: 'Failed',
      monthly: 'Monthly',
      yearly: 'Yearly',
    },
    common: {
      view: 'View',
      viewAll: 'View all',
      retry: 'Retry',
      refresh: 'Refresh',
      save: 'Save',
      cancel: 'Cancel',
      delete: 'Delete',
      edit: 'Edit',
      create: 'Create',
      search: 'Search',
      filter: 'Filter',
      actions: 'Actions',
      loading: 'Loading...',
      noData: 'No data',
      confirm: 'Confirm',
      success: 'Success',
      error: 'Error',
      yes: 'Yes',
      no: 'No',
      back: 'Back',
      profile: 'Profile',
      folders: 'Folders',
      documents: 'Documents',
      jobs: 'Jobs',
      billing: 'Billing',
      subscription: 'Subscription',
      usage: 'Usage',
      statistics: 'Statistics',
      currentPeriod: 'Current Period',
      charsUsed: 'Characters Used',
      charsLimit: 'Limit',
      storage: 'Storage',
      activeUsers: 'Active Users',
      totalUsers: 'Total Users',
      mrr: 'MRR',
      activeSubscriptions: 'Active Subscriptions',
      failedPayments: 'Failed Payments',
      pastDue: 'Past Due',
      queueDepth: 'Queue Depth',
      runningJobs: 'Running Jobs',
      completedJobs: 'Completed Jobs',
    },
    tts: {
      voiceSelection: 'Voice selection',
      modelSelection: 'Model selection',
      status: {
        pending: 'Pending',
        queued: 'Queued',
        processing: 'Processing',
        completed: 'Completed',
        failed: 'Failed',
        cancelled: 'Cancelled',
      },
    },
  },
};

export default messages;
